// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 592 ? "c15bf2b0" : chunkId) + "." + {"415":"37a463b4bebfd6dc","478":"7b207867e03911da","592":"ead7a7552b15bf32"}[chunkId] + ".js";
};